export const StateStr = [
    '未发布',
    '已发布',
    '已撤回',
    '已删除'
]
export const ActionStr = [
    '新建',
    '发布',
    '撤回',
    '删除'    
]
export const ResourceTypeStr = [
    '',
    '图片',
    '视频',
    'PDF',
    '音频'
]
export const ResourceTypeIcon = [
    '',
    'el-icon-picture-outline',
    'el-icon-video-camera',
    'el-icon-document',
    'el-icon-headset'
]
export const ResourceUploadConfig = [
    {},
    {
        accept: 'image/png,image/jpeg',
        sizeLimit: 10*1024*1024,
        tipText: '支持jpg、png格式，尺寸不大于10M'
    },
    {
        accept: 'video/mp4,video/avi',
        sizeLimit: 500*1024*1024,
        tipText: '支持mp4、avi格式，尺寸不大于500M'
    },
    {
        accept: 'application/pdf',
        sizeLimit: 50*1024*1024,
        tipText: 'pdf尺寸不大于50M'
    },
    {
        accept: 'audio/mp3',
        sizeLimit: 500*1024*1024,
        tipText: '支持mp3格式，尺寸不大于500M'
    }            
]